'use client';

import PrescriptionDialog, { BdDialog, ColdDialog, DhakaDialog } from '@/components/molecules/ProductDialogs';
import useProduct from '@/contexts/ProductProvider';
import React from 'react';

const DialogWrapper = () => {
	const { product } = useProduct();

	return (
		<>
			{product?.p_note1?.includes('শুধুমাত্র ঢাকা শহরে ডেলিভারি') ? <DhakaDialog /> : <BdDialog />}

			{!!product?.p_cold && <ColdDialog />}
			{!!product?.p_rx_req && <PrescriptionDialog />}
		</>
	);
};

export default DialogWrapper;
